
const benefits = [
  {
    icon: 'ri-search-eye-line',
    title: 'Avaliação Gratuita e Precisa',
    description: 'Análise completa do mercado imobiliário de Brasília para definir o preço ideal do seu imóvel e maximizar seu retorno.',
    color: 'bg-teal-50 text-teal-600',
  },
  {
    icon: 'ri-megaphone-line',
    title: 'Divulgação Premium',
    description: 'Seu imóvel nos principais portais (ZAP, Viva Real, OLX), redes sociais e nossa carteira exclusiva de compradores e locatários.',
    color: 'bg-emerald-50 text-emerald-600',
  },
  {
    icon: 'ri-camera-3-line',
    title: 'Fotos e Tour Virtual',
    description: 'Produção fotográfica profissional e tour virtual 360° para destacar seu imóvel e atrair mais interessados qualificados.',
    color: 'bg-orange-50 text-orange-600',
  },
  {
    icon: 'ri-file-shield-2-line',
    title: 'Segurança Jurídica Total',
    description: 'Toda a documentação, contratos e processos legais cuidados por nossa equipe especializada. Você não precisa se preocupar com nada.',
    color: 'bg-rose-50 text-rose-600',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Compradores Qualificados',
    description: 'Filtramos e qualificamos todos os interessados antes de apresentá-los ao seu imóvel, economizando seu tempo e garantindo seriedade.',
    color: 'bg-violet-50 text-violet-600',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Relatórios de Desempenho',
    description: 'Acompanhe em tempo real quantas pessoas visualizaram, visitaram e demonstraram interesse no seu imóvel. Transparência total.',
    color: 'bg-cyan-50 text-cyan-600',
  },
];

const BenefitsSection = () => (
  <section className="py-24 bg-white">
    <div className="container mx-auto px-4">
      <div className="text-center mb-16">
        <span className="inline-block px-4 py-2 bg-teal-100 rounded-full text-teal-700 font-semibold text-sm tracking-wider uppercase mb-4">
          Por Que Escolher a Daniel Carvalho?
        </span>
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
          Tudo Que Você Precisa Para{' '}
          <span className="bg-gradient-to-r from-teal-600 to-emerald-600 bg-clip-text text-transparent">
            Vender ou Alugar
          </span>
        </h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Uma solução completa para proprietários em Brasília que querem resultado rápido, seguro e pelo melhor valor
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {benefits.map((b, i) => (
          <div
            key={i}
            className="group bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-xl transition-all hover:-translate-y-1"
          >
            <div className={`w-14 h-14 ${b.color} rounded-xl flex items-center justify-center mb-5`}>
              <i className={`${b.icon} text-2xl`}></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-3">{b.title}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">{b.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default BenefitsSection;
